module.exports = __webpack_public_path__ + "static/media/bag.2c52998f.svg";